import Component from "./ChipUser";
import Icon from "./components/Icon/ChipUserIcon";
import Label from "./components/Label/ChipUserLabel";

interface IChipUserExtensions {
    Icon: typeof Icon;
    Label: typeof Label;
}

export const ChipUser: typeof Component & IChipUserExtensions = Object.assign(
    Component,
    {
        Icon,
        Label,
    },
);
